import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RevenueDepartmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RevenueDepartmentsQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly revenueDepartments: { readonly __typename?: 'RevenueDepartmentsConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RevenueDepartment', readonly id: string, readonly name: string }> } } };

export type GetPriceListQueryVariables = Types.Exact<{
  input: Types.PriceListItemsInput;
  options?: Types.InputMaybe<Types.PriceListItemsOptions>;
}>;


export type GetPriceListQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly priceListItems: { readonly __typename?: 'PriceableItemConnection', readonly pageInfo: { readonly __typename?: 'PriceableItemConnectionPageInfo', readonly pageNumber: number, readonly pageSize: number, readonly totalRows: number }, readonly edges: ReadonlyArray<{ readonly __typename?: 'PriceableItem', readonly id: string, readonly name: string, readonly externalReference: { readonly __typename?: 'PriceableItemExternalReference', readonly origin: Types.PriceableItemOrigin }, readonly prices: ReadonlyArray<{ readonly __typename?: 'ItemPrice', readonly id: string, readonly value: number, readonly owner: Types.ItemPriceOwner, readonly active: boolean, readonly tariff: { readonly __typename?: 'PriceTariff', readonly id: string, readonly name: string }, readonly revenueDepartment: { readonly __typename?: 'RevenueDepartment', readonly id: string, readonly name: string }, readonly parentPrice?: { readonly __typename?: 'ItemPrice', readonly id: string, readonly value: number, readonly owner: Types.ItemPriceOwner, readonly active: boolean, readonly tariff: { readonly __typename?: 'PriceTariff', readonly id: string, readonly name: string }, readonly revenueDepartment: { readonly __typename?: 'RevenueDepartment', readonly id: string, readonly name: string } } | null }> }>, readonly meta: { readonly __typename?: 'PriceListMeta', readonly linkedToOrganisation?: boolean | null, readonly facilityId?: string | null } } } };


export const RevenueDepartmentsDocument = gql`
    query revenueDepartments {
  priceListV2 {
    revenueDepartments {
      edges {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useRevenueDepartmentsQuery__
 *
 * To run a query within a React component, call `useRevenueDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRevenueDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<RevenueDepartmentsQuery, RevenueDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevenueDepartmentsQuery, RevenueDepartmentsQueryVariables>(RevenueDepartmentsDocument, options);
      }
export function useRevenueDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevenueDepartmentsQuery, RevenueDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevenueDepartmentsQuery, RevenueDepartmentsQueryVariables>(RevenueDepartmentsDocument, options);
        }
export type RevenueDepartmentsQueryHookResult = ReturnType<typeof useRevenueDepartmentsQuery>;
export type RevenueDepartmentsLazyQueryHookResult = ReturnType<typeof useRevenueDepartmentsLazyQuery>;
export type RevenueDepartmentsQueryResult = Apollo.QueryResult<RevenueDepartmentsQuery, RevenueDepartmentsQueryVariables>;
export const GetPriceListDocument = gql`
    query getPriceList($input: PriceListItemsInput!, $options: PriceListItemsOptions) {
  priceListV2 {
    priceListItems(input: $input, options: $options) {
      pageInfo {
        pageNumber
        pageSize
        totalRows
      }
      edges {
        id
        name
        externalReference {
          origin
        }
        prices {
          id
          value
          owner
          active
          tariff {
            id
            name
          }
          revenueDepartment {
            id
            name
          }
          owner
          parentPrice {
            id
            value
            owner
            active
            tariff {
              id
              name
            }
            revenueDepartment {
              id
              name
            }
            owner
          }
        }
      }
      meta {
        linkedToOrganisation
        facilityId
      }
    }
  }
}
    `;

/**
 * __useGetPriceListQuery__
 *
 * To run a query within a React component, call `useGetPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetPriceListQuery(baseOptions: Apollo.QueryHookOptions<GetPriceListQuery, GetPriceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceListQuery, GetPriceListQueryVariables>(GetPriceListDocument, options);
      }
export function useGetPriceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceListQuery, GetPriceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceListQuery, GetPriceListQueryVariables>(GetPriceListDocument, options);
        }
export type GetPriceListQueryHookResult = ReturnType<typeof useGetPriceListQuery>;
export type GetPriceListLazyQueryHookResult = ReturnType<typeof useGetPriceListLazyQuery>;
export type GetPriceListQueryResult = Apollo.QueryResult<GetPriceListQuery, GetPriceListQueryVariables>;